import React from 'react';

/**
 * Shared chart tooltip that respects light/dark theme via CSS vars.
 * Usage: <Tooltip content={<ChartTooltip />} />
 */
export default function ChartTooltip({ active, payload, label, formatter }) {
  if (!active || !payload?.length) return null;
  return (
    <div style={styles.wrap}>
      {label != null && <div style={styles.label}>{label}</div>}
      {payload.map((p, i) => {
        const val = formatter ? formatter(p.value, p.name) : (typeof p.value === 'number' ? p.value.toLocaleString() : p.value);
        return (
          <div key={i} style={styles.row}>
            <span style={{ ...styles.dot, background: p.color }} />
            <span style={styles.name}>{p.name}</span>
            <span style={{ ...styles.val, color: p.color }}>{val}</span>
          </div>
        );
      })}
    </div>
  );
}

const styles = {
  wrap: {
    background: 'var(--tooltip-bg)',
    border: '1px solid var(--tooltip-border)',
    borderRadius: 10,
    padding: '10px 14px',
    fontSize: 12,
    boxShadow: 'var(--shadow-sm)',
    minWidth: 140,
  },
  label: { color: 'var(--text3)', marginBottom: 8, fontWeight: 600, fontSize: 11 },
  row:   { display: 'flex', alignItems: 'center', gap: 7, marginTop: 4 },
  dot:   { width: 8, height: 8, borderRadius: '50%', flexShrink: 0 },
  name:  { color: 'var(--text2)', flex: 1 },
  val:   { fontWeight: 700, fontFamily: 'Space Mono, monospace', fontSize: 11 },
};
